import React from "react";
import BarraSupDent from "../../commons/BarraSupDent";
import Title from "../Login/Components/title/title";
import RequestInfo from "../Finding_a_Denter/Component/RequestInfo";
import "../Finding_a_Denter/Component/RequestInfo.css";
import "../In_progress/In_progress.css";
import AddButton from "../../commons/AddButton";

const In_progress = () => {
  return (
    <React.Fragment>
      <BarraSupDent />
      <Title text="Thank you!" />
      <RequestInfo />
      <div className="mx-auto sizeBox mt-5 mb-4">
        <p className="text-center">Appointment Summary: </p>
        <label className="appointment">
          <b>Estimate Cost:</b>
        </label>
        <label className="appointment">
          <b>Technician:</b>
        </label>
        <label className="appointment">
          <b>Appointment Time:</b>
        </label>
        <label className="appointment">
          <b>Address:</b>
        </label>
      </div>
      <AddButton text="Contact technician" />
    </React.Fragment>
  );
};

export default In_progress;
